import React, { useState, useRef } from "react";
import { StoryblokComponent, storyblokEditable } from "gatsby-source-storyblok";
import * as styles from "./landingAccordion.module.css"

const LandingAccordion = ({ blok }) => {

  // console.log(blok)
  const [isOpen, setIsOpen] = useState(false);
  const contentRef = useRef(null);

  const toggleAccordion = () => {
    const content = contentRef.current;
    if (content.style.height) {
      content.style.height = null;
    } else {
      content.style.height = `${content.scrollHeight}px`;
    }
    setIsOpen(!isOpen);
  }
  
  return (
    <div id={blok?.id} className="container max-w-screen-lg mx-auto flex flex-col" {...storyblokEditable(blok)} style={{
      paddingTop: `${blok.paddingTop}px`, paddingBottom: `${blok.paddingBottom}px`,
    }}>
      <div className={`w-full border-black border-t border-b mt-[-1px] ${isOpen ? styles.accordionButton : ''}`} 
        style={{backgroundImage: `linear-gradient(to right, transparent, white, ${blok.headColor?.color})`}}>
        <button
          onClick={toggleAccordion}
          className={`py-3 px-4 w-full text-left text-xl font-serif`}>
            <img className="inline-block w-6 h-6 mr-2" loading="lazy" src={isOpen ? "/icons/minus.svg" : "/icons/plus.svg"} alt="Toggle" />
          {blok.heading}
        </button>
      </div>
      <div 
        ref={contentRef} 
        className={`${styles.bodyContent} overflow-hidden transition-height duration-500 ease-in-out h-0 px-3`}>
          {blok.body?.map((nestedBlok) => (<StoryblokComponent blok={nestedBlok} key={nestedBlok._uid}/>))}
      </div>
    </div>
    )
}

export default LandingAccordion
